import AddDocumentsContainer from './add-documents-container';

export default AddDocumentsContainer;
